<template>
  <div class="circlechart">
    <div class="circlechart__svg" :id="'circlechart--' + this._uid"></div>
    <div class="circlechart__value" v-if="valueExists()">{{ getFixedValue(value) }}</div>
    <div class="circlechart__value" v-else>N/A</div>
  </div>
</template>

<script>
// import Vue from 'vue'
import SVG from 'svg.js'
import _ from 'lodash'

export default {
  name: 'circlechart',
  props: {
    value: {
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      hasBeenAnimated: false,
      animationSpeed: 750,
      canvas: false,
      canvasSize: [100, 100],
      widthHeight: [40, 40],
      lineWidth: 15,
      groups: []
    }
  },
  watch: {
    value () {
      this.reset()
      this.drawChart()
    }
  },
  mounted () {
    this.drawCanvas()
    this.drawChart()
  },
  methods: {
    reset () {
      _.each(this.groups, (group) => {
        group.remove()
      })
      this.hasBeenAnimated = false
    },

    valueExists () {
      return this.value !== undefined && !isNaN(this.value)
    },

    drawChart () {
      let group = this.canvas.group()

      group.add(this.drawCircle(1, 'svg-stroke--gray-lightest'))

      if (this.valueExists()) {
        group.add(this.drawCircle(parseFloat(this.value), 'svg-stroke--' + this.color, this.animationSpeed))
      }

      this.groups.push(group)
    },

    /**
     * Initialize the SVG convas
     */
    drawCanvas () {
      this.canvas = SVG('circlechart--' + this._uid).size(this.widthHeight[0] + 'px', this.widthHeight[1] + 'px')
      this.canvas.viewbox(0, 0, this.canvasSize[0], this.canvasSize[1])
      this.canvas.style({ width: this.widthHeight[0] + 'px', height: this.widthHeight[1] + 'px' })
    },

    /**
     * Draws a circle
     * @param  {Float}  value           The value
     * @param  {String}  className      ClassName
     * @param  {Boolean/Integer} speed  The animation speed - or false if no animatino
     * @return {Object}                 The svgjs circle object
     */
    drawCircle (value, className, speed = false) {
      let d = this.canvasSize[0] - this.lineWidth
      let r = d / 2
      let circleLength = 2 * Math.PI * r

      let circle = this.canvas.circle(d)
        .fill('none')
        .stroke({ width: this.lineWidth, dasharray: '0,' + circleLength })
        .rotate(-90, this.canvasSize[0] / 2, this.canvasSize[0] / 2)
        .move(this.lineWidth / 2, this.lineWidth / 2)
        .addClass(className)

      let animateTo = circleLength * value

      if (this.hasBeenAnimated === false && speed !== false) {
        // Animate - but only the first time
        circle.animate(speed, '>').stroke({ dasharray: animateTo + ',' + circleLength }).afterAll(() => {
          this.hasBeenAnimated = true
        })
      } else {
        circle.stroke({ dasharray: animateTo + ',' + circleLength })
      }

      return circle
    }

  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .circlechart__svg{
    font-size: 0;
    line-height: 0;
    margin: 0;
    padding: 0;
  }

  .circlechart{ position: relative; }
  .circlechart__value{
    align-items: center;
    bottom: 0;
    display: flex; -js-display: flex;
    font-size: 9px;
    line-height: 1;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    @media (max-width: 1100px) {
      font-size: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/charts/CircleChart.vue